import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum ENewReviewLoadingError {
  Set = 'NEW_REVIEW/LOADING_ERROR/SET',
}

export type TNewReviewError = ITypedReduxAction<ENewReviewLoadingError.Set, boolean>;

export type TNewReviewLoadingErrorActions = TNewReviewError;

export const setLoadingError: (hasError: boolean) => TNewReviewError = actionGenerator<
  ENewReviewLoadingError.Set,
  boolean
>(ENewReviewLoadingError.Set);
